import React, { useState } from 'react';
import { emptyspace, pm1, pm2, pm3, pm4, pm5, pm6, pm7 } from '../../assets/assets';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Checkout = () => {
  const [cardNumber, setCardNumber] = useState('');
  const [email, setEmail] = useState('');
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  return (
    <div className="min-h-screen bg-[#F5F5F5] flex flex-col-reverse md:flex-row ">
      {/* Left side - Form */}
      <div className="flex-1 p-8 bg-white">
        <div className="max-w-md mx-auto">
          {/* Header */}
          <div className="mb-8">
          <h1 className="text-2xl font-semibold text-[#174568] hidden">
            Hello<span className="text-[#7295B8]">cer</span>
          </h1>
          
            <h1 className="text-[40px] font-semibold mt-2 text-[#174568] font-poppins mb-6">
              Choose
              payment method
            </h1>
          </div>

          {/* Payment Methods */}
          <div className="mb-6">
            <div className="grid grid-cols-4 gap-5">
              <img src={pm1} alt="Mastercard" className="h-6" />
              <img src={pm2} alt="Visa" className="h-6" />
              <img src={pm3} alt="PayPal" className="h-6" />
              <img src={pm4} alt="Bitcoin" className="h-6" />
               <img src={pm7} alt="MasterCard" className="h-6" />
              <img src={pm5} alt="MasterCard" className="h-6" />
              <img src={pm6} alt="MasterCard" className="h-6" />
            </div>
            
          
          </div>

          {/* Form */}
          <div className="space-y-4">
            {/* Name on Card */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Name on Card
              </label>
              <input
                type="text"
                placeholder="Your first name"
                className="w-full px-3 py-2 border border-[#DFEAF2] bg-[#FFFFFF] rounded-[15px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
            </div>

            {/* Card Number */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Card number
              </label>
              <div className="flex gap-2 border border-[#DFEAF2] bg-[#FFFFFF] rounded-[15px]">
                <input
                  type="text"
                  placeholder="xxxx xxxx xxxx"
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                  className="flex-1 px-3 py-2  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />

                    <input
                  type="text"
                  placeholder="MM/YY"
                  className="w-16 px-3 py-2  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-center"
                />

                <input
                  type="text"
                  placeholder="CVV"
                  className="w-16 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm text-center"
                />

              
              </div>
            </div>

            {/* Email Address */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-[#DFEAF2] bg-[#FFFFFF] rounded-[15px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
              />
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-center gap-2 mt-6">
              <input
                type="checkbox"
                id="terms"
                checked={agreeToTerms}
                onChange={(e) => setAgreeToTerms(e.target.checked)}
                className="mt-1 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <label htmlFor="terms" className="text-xs text-gray-600 leading-tight">
                By continuing this order I accept the terms of the user agreement
              </label>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 mt-8">
              <button
                type="button"
                className="bg-[#174568] text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-gray-800 transition-colors"
              >
                CHECKOUT
              </button>
              <button
                type="button"
                className="text-gray-600 border border-[#BAC0C2] rounded-[5px] px-6 py-2 text-sm hover:text-gray-800 transition-colors"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Right side - Image */}
      <div className=" relative py-4 md:py-0">

        <div className="w-[80%] mx-auto mb-5 flex items-center md:hidden justify-between">
        <h1 className="text-2xl font-semibold text-[#174568]">
            Hello<span className="text-[#7295B8]">cer</span>
          </h1>
          <Link to={"/"}>
          <X size={24} className="text-gray-800" />
          </Link>
          </div>

       <img src={emptyspace} className='w-[80%] h-[256px] object-cover mx-auto md:w-full md:h-full' draggable={false}/>
      </div>
    </div>
  );
};

export default Checkout;